import { render, staticRenderFns } from "./StoreBranchGoodsHome.vue?vue&type=template&id=33a72506"
import script from "./StoreBranchGoodsHome.vue?vue&type=script&lang=js"
export * from "./StoreBranchGoodsHome.vue?vue&type=script&lang=js"
import style0 from "./StoreBranchGoodsHome.vue?vue&type=style&index=0&id=33a72506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports